module.exports = __webpack_public_path__ + "static/media/mtn-tv-512x512.d42d4c23.png";